import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_1/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/SlowFastFan/1_1x.png`;
const Pic2 = `${FullPath}/SlowFastFan/2_1x.png`;
const Pic3 = `${FullPath}/SlowFastFan/3_1x.png`;
const Pic4 = `${FullPath}/SlowFastFan/4_1x.png`;
const Pic5 = `${FullPath}/SlowFastFan/5_1x.png`;
const Pic6 = `${FullPath}/SlowFastFan/6_1x.png`;
const Pic7 = `${FullPath}/SlowFastFan/7_1x.png`;
const Pic8 = `${FullPath}/SlowFastFan/8_1x.png`;
const Pic9 = `${FullPath}/SlowFastFan/9_1x.png`;
const Pic10 = `${FullPath}/SlowFastFan/10_1x.png`;
const Pic11 = `${FullPath}/SlowFastFan/11_1x.png`;
const Pic12 = `${FullPath}/SlowFastFan/12_1x.png`;
const Pic13 = `${FullPath}/SlowFastFan/13_1x.png`;
const Pic14 = `${FullPath}/SlowFastFan/14_1x.png`;
const Pic15 = `${FullPath}/SlowFastFan/15_1x.png`;
const Pic16 = `${FullPath}/SlowFastFan/16_1x.png`;
const Pic17 = `${FullPath}/SlowFastFan/17_1x.png`;
const Pic18 = `${FullPath}/SlowFastFan/18_1x.png`;







export const Buildingimages = [

]
const Pics = [
    Pic1,
    Pic2,
    Pic3,
    Pic4,
    Pic5,
    Pic6,
    Pic7,
    Pic8,
    Pic9,
    Pic10,
    Pic11,
    Pic12,
    Pic13,
    Pic14,
    Pic15,
    Pic16,
    Pic17,
    Pic18,

]


for (let i = 0; i < Pics.length; i++) {
    let obj = {};
    obj['original'] = Pics[i];
    obj['thumbnail'] = Pics[i];
    Buildingimages.push(obj);
}

export default {
    Buildingimages,
}